import { AxiosResponse } from 'axios';
import userClient from 'src/api/userClient';
import { UserInspectorResource } from 'types/userAccount';

export const createUpdateInspectorAccount = (
  inspectorEmail: string
): Promise<AxiosResponse<UserInspectorResource>> => {
  return userClient.post<UserInspectorResource>(
    `/api/User/CreateOrActivedInspectorDTAccount?email=${inspectorEmail}`
  );
};

export default createUpdateInspectorAccount;
